import Vue from 'vue'
import App from '@/app.vue'
import router from '@/router'
import store from '@/store'
import vuetify from '@/plugins/vuetify'
import '@/plugins/contentful'
import '@/plugins/vue-meta'
import '@/plugins/vue-scroll-to'
import '@/plugins/array-extensions'
import '@/plugins/string-extensions'
import '@/plugins/directives'
import '@/plugins/filters'
import '@/plugins/auto-declare'
import '@/plugins/axios'
import '@/plugins/session-data'
import '@mdi/font/css/materialdesignicons.css'
import '@fortawesome/fontawesome-free/css/all.css'
import '@/styles/app.scss'
import { ERROR_TYPES } from '@/store/modules/error'
import CtfRichTextAssetLink from '@/components/snippets/ctf-rich-text/ctf-rich-text-asset-link.vue'
import CtfRichTextLink from '@/components/snippets/ctf-rich-text/ctf-rich-text-link.vue'
import CtfRichText from '@/components/snippets/ctf-rich-text/ctf-rich-text'
import CtfRichTextEmbedAsset from '@/components/snippets/ctf-rich-text/ctf-rich-text-embed-asset.vue'
import CtfRichTextExternalLink from '@/components/snippets/ctf-rich-text/ctf-rich-text-external-link'
import CtfRichTextHeading from '@/components/snippets/ctf-rich-text/ctf-rich-text-heading'

Vue.config.productionTip = false

/* This error handler will dispatch an action that will set the error in state and log it to App Insights,
 * and then it will redirect to the error page.
 * Any errors caught here that were NOT first caught by the errorCaptured hook
 * will likely require a page refresh to get the app working again.
*/
Vue.config.errorHandler = (err, vm, info) => {
  err.message = `${err.message} | info: ${info} | vm.$vnode.tag: ${vm.$vnode.tag}`
  console.error(err)
  vm.$store.dispatch(ERROR_TYPES.actions.setError, err)

  // REMOVING THIS BELOW: Seems like this just takes down the entire site if any component encounters an error? Just letting the component fail and not redirecting the user. Site should remain 99% functional

  // if (vm.$route.path !== '/error') {
  //   vm.$router.push('/error')
  //     .catch(() => {}) // An error will be thrown if a navigation event was cancelled, but that's fine so just catch and do nothing
  // }
}

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')

Vue.component('ctf-rich-text', CtfRichText)
Vue.component('ctf-rich-text-asset-link', CtfRichTextAssetLink)
Vue.component('ctf-rich-text-link', CtfRichTextLink)
Vue.component('ctf-rich-text-embed-asset', CtfRichTextEmbedAsset)
Vue.component('ctf-rich-text-external-link', CtfRichTextExternalLink)
Vue.component('ctf-rich-text-heading', CtfRichTextHeading)
